export const statusOptions = [
    "applied", 
    "hired", 
    "interview", 
    "offered",
    "rejected",
    "shortlisted"
];